// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const BASE_URL = "https://ecom.cyberathon.com";
// const API_URL = BASE_URL + "/index.php/Blank/get_list_for_statistics";

// function HomeStatistics() {
//   const [stats, setStats] = useState([]);

//   useEffect(() => {
//     const fetchStatistics = async () => {
//       try {
//         const response = await axios.get(API_URL);
//         setStats(response.data.data || []);
//       } catch (error) {
//         console.error("Error loading statistics:", error);
//       }
//     };

//     fetchStatistics();
//   }, []);

//   return (
//     <>
//       <div className="container-fluid px-5 py-3 my-3" style={{ backgroundColor: "azure" }}>
//         <div className="row g-3 align-items-stretch">

//           {stats.map((item, index) => (
//             <div key={index} className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
//               <div className={`custombox${index + 1} rounded-4 d-flex flex-column justify-content-center p-2`}>
                
//                 <div className="d-flex align-items-center mb-2">
//                   <div className="icon-square me-2 ms-3">
//                     <i className="bi bi-people bg-icon"></i>
//                   </div>

//                   <h5 className="fw-bold text-dark mb-0">{item.digit}</h5>
//                 </div>

//                 <h5 className="text-dark text-start ms-3">{item.description}</h5>

//               </div>
//             </div>
//           ))}

//         </div>
//       </div>
//     </>
//   );
// }

// export default HomeStatistics;



import React, { useEffect, useState } from "react";
import axios from "axios";

const BASE_URL = "https://ecom.cyberathon.com";
const API_URL = BASE_URL + "/index.php/Blank/get_list_for_statistics";

function HomeStatistics() {
  const [stats, setStats] = useState([]);

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        const response = await axios.get(API_URL);
        setStats(response.data.data || []);
      } catch (error) {
        console.error("Error loading statistics:", error);
      }
    };

    fetchStatistics();
  }, []);

  // 🔥 Function to format number with K+
  const formatDigit = (value) => {
    if (!value) return "";

    let str = value.toString().trim().toUpperCase();

    // If already contains K+ then return as is
    if (str.includes("K+")) return str;

    // If contains only K, convert to K+
    if (str.includes("K")) return str.replace("K", "K+");

    // Otherwise add K+
    return `${str}K+`;
  };

  const icons = [
  "bi-box-seam",        // 1st
  "bi-people",      // 2nd
  "bi-shield-check",  // 3rd
  "bi-truck"          // 4th
];

  return (
    <>
      <div className="container-fluid px-sm-2 px-md-5 py-3 my-3" style={{ backgroundColor: "azure" }}>
        <div className="row g-3 align-items-stretch">

          {stats.slice(0, 4).map((item, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
              <div className={`custombox${index + 1} rounded-4 d-flex flex-column justify-content-center  p-2`}>
                
                <div className="d-flex align-items-center mb-2">
                  <div className="icon-square me-2 ms-3">
                    <i className={`bi ${icons[index] || "bi-circle"} bg-icon`}></i>
                  </div>

                  {/* <h5 className="fw-semibold text-dark mb-0">{formatDigit(item.digit)}</h5> */}
                                <h5 className="fw-semibold text-dark mb-0">{item.digit}</h5>

                </div>

                <h5 className="text-dark text-start mars ms-md-4">{item.description}</h5>

              </div>
            </div>
          ))}

        </div>
      </div>
    </>
  );
}

export default HomeStatistics;
